// extracted by mini-css-extract-plugin
module.exports = {"intakeHolder":"IntakeContentHolder_intakeHolder__3rCws","fadein":"IntakeContentHolder_fadein__3IsIy"};